import axios from 'axios';
import store from '../../modules/index';

const kecamatan = 
{
    namespaced: true,
    state: {
        data_model:[],
    },
    mutations: 
    {
        FETCH_DATA: (state, payload) => {
            state.data_model  = payload;
        }
    },
    actions: {

        async all({ commit }, id_kota) 
        {
            store.state.isLoading.status = true;
            return await axios.post('location/kecamatan-data',
            {
                where : {key : 'teritori_kecamatan.kota_id', value : id_kota},
                order :{ key : 'id', value : 'asc' },
                query_type : 'all'
            })
            .then((response) => {
                commit("FETCH_DATA", response.data);
                return response.data;
            }).finally(() => {
                store.state.isLoading.status = false;
            });
        },
    }
}

export default kecamatan